<template>
  <div class="row">
    <div class="col-12">
      <PageHeader
        :page="page"
        :has-add="true"
        :has-return="true"
        @onAdd="goToAddComment()"
        @onReturn="() => $router.back()"
      />
      <!-- Search box -->
      <div class="container-search ml-3 mr-3">
        <ValidationObserver ref="formValidator" v-slot="{}" tag="form">
          <div class="row">
            <div class="col-md-2 col-sm-12">
              <ValidationProvider
                v-slot="{}"
                name="año academico"
                rules="required"
              >
                <vselect
                  v-model="Filter.AcademicYear"
                  :options="AcademicYears"
                  :reduce="(Academic) => Academic.id"
                  label="description"
                  placeholder="Año académico"
                />
              </ValidationProvider>
            </div>

            <div class="col-md-2 col-sm-12">
              <vselect
                ref="SelectModule"
                v-model="Filter.ModuleId"
                :options="modules"
                :reduce="(Module) => Module.id"
                label="name"
                placeholder="Módulo"
                @input="handleModuleChange"
              />
            </div>

            <div class="col-md-3 col-sm-12">
              <vselect
                ref="SelectCategoryType"
                v-model="Filter.CategoryTypeId"
                :options="categories"
                :reduce="(CategoryType) => CategoryType.id"
                label="name"
                placeholder="Categoría"
                :disabled="!Filter.ModuleId"
                @input="handleCategoryChange"
              />
            </div>

            <div class="col-md-2 col-sm-12">
              <CustomDatePicker
                v-model="Filter.StartDate"
                class="d-flex justify-content-center"
                class-container="w-100"
                :min-date="minDate"
                :max-date="maxStartDate"
                :open-date="minDate"
                placeholder="DD/MM/YY"
                :disabled="disableDates"
              />
            </div>

            <div class="col-md-2 col-sm-12">
              <CustomDatePicker
                v-model="Filter.EndDate"
                class="d-flex justify-content-center"
                class-container="w-100"
                :min-date="minEndDate"
                :max-date="maxDate"
                :open-date="maxDate"
                placeholder="DD/MM/YY"
                :disabled="disableDates"
              />
            </div>

            <div class="col-md-1 col-sm-12">
              <ActionButton
                variant="success btn-block"
                i="fas fa-search"
                @click="getHistory"
              >
                Buscar
              </ActionButton>
            </div>
          </div>
        </ValidationObserver>
      </div>

      <!-- Search box -->
      <custom-separator class="mt-1 mb-4" text="Historial de Comentarios" />

      <!-- Student comments -->
      <div class="row mt-4 ">
        <div class="col-12">
          <CommentList ref="CommentList" :filters="Filter" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/common/page/PageHeader';
import { ActionButton } from '@/components/common';
import CustomSeparator from 'custom-separator';
import { SectionTitle } from '@/components/pei/shared';
import CommentList from '@/views/comments/history/CommentList';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import vselect from 'vue-select';
import mixWait from '@/mixin/loading.mixin';
import mixAlert from '@/mixin/alert.mixin';
import store from '@/store/index';
import codeViewTypes from '@/utils/constants/comment/CodeViewTypes.js';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import commentsStore from '@/views/comments/comments-store';

export default {
  mixins: [mixWait, mixAlert],
  name: 'StudentSearchComment',
  components: {
    SectionTitle,
    CommentList,
    vselect,
    ValidationProvider,
    ValidationObserver,
    ActionButton,
    CustomSeparator,
    PageHeader,
    CustomDatePicker,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-file-alt',
        title: 'Comentarios',
        routes: ['Inicio', 'Estudiante', 'Comentarios'],
      },
      Filter: {
        AcademicYear: null,
        ModuleId: null,
        CategoryTypeId: null,
        StartDate: null,
        EndDate: null,
      },
      AcademicYears: [],
      validationMessages: [],
      errorMessage: '',
      disableDates: false,
    };
  },
  methods: {
    handleModuleChange(value) {
      this.Filter.CategoryTypeId = null;
      commentsStore.commit('setSelectedModule', value);
      commentsStore.commit('setSelectedCategory', null);
    },
    handleCategoryChange(value) {
      commentsStore.commit('setSelectedCategory', value);
    },
    goToAddComment() {
      const self = this;
      store.dispatch('setExit', null);
      self.$router.push({
        name: 'studentAddComment',
        params: {
          commentDate: new Date(),
          studentSieId: this.$route.params.studentSieId,
          categoryId: this.Filter.CategoryTypeId,
          codeViewTypeId: codeViewTypes.AnadirComentario,
        },
      });
    },
    async loadValidationMessages() {
      const res = await this.$ApiGet(
        '/api/validationsmessages?messageCodes=18018'
      );
      this.validationMessages = res.data;
    },
    getMessage(code) {
      const message = this.validationMessages.find(
        (element) => element.id == code
      );
      return message;
    },
    async LoadAcademicYears(studentsieId) {
      try {
        const response = await this.$ApiGet(
          'api/academicyears/getallforstudentcomments',
          { studentsieId: studentsieId }
        );
        this.AcademicYears = response.data;
        if (this.academicYearIdFromPreviosPage) {
          const academicYear = response.data.find(
            (x) => x.id == this.academicYearIdFromPreviosPage
          );
          this.Filter.AcademicYear = academicYear ?? response.data[0].id;
        } else if (response.data.length > 0) {
          this.Filter.AcademicYear = response.data[0].id;
        }
      } catch (errm) {
        this.ShowToast(errm.message, '', 'error');
      }
    },
    async initFilters() {
      const studentSieId =
        this.$route.params.studentSieId ??
        this.$store.getters.SelectedStudent.studentId;
      const categoryId =
        this.$route.params.categoryId ??
        commentsStore.getters.filters.categoryId;

      const payload = {
        categoryId: categoryId,
        studentSieId: studentSieId,
      };

      await commentsStore.dispatch('init', payload);
      await this.LoadAcademicYears(studentSieId);

      this.Filter.ModuleId = commentsStore.getters.filters.moduleId;
      this.Filter.CategoryTypeId = commentsStore.getters.filters.categoryId;
    },
    async getHistory() {
      let isValid = await this.$refs.formValidator.validate();
      if (!isValid || this.Filter.AcademicYear === null) {
        this.ShowToast(this.getMessage('18018').name, '', 'error');
        return;
      }

      this.$refs.CommentList.getHistory();
    },
  },
  computed: {
    modules() {
      return commentsStore.getters.modules;
    },
    categories() {
      return commentsStore.getters.categories;
    },
    selectedAcademicYear() {
      if (!this.Filter.AcademicYear) return null;

      return this.AcademicYears.find((x) => x.id == this.Filter.AcademicYear);
    },
    maxDate() {
      return this.selectedAcademicYear?.toDate
        ? new Date(this.selectedAcademicYear?.toDate)
        : new Date();
    },
    minDate() {
      return this.selectedAcademicYear?.fromDate
        ? new Date(this.selectedAcademicYear?.fromDate)
        : null;
    },
    maxStartDate() {
      if (this.Filter.EndDate) {
        return this.Filter.EndDate;
      }

      return this.maxDate;
    },
    minEndDate() {
      if (this.Filter.StartDate) {
        return this.Filter.StartDate;
      }

      return this.minDate;
    },
    academicYearIdFromPreviosPage() {
      return this.$route?.params?.academicYearId;
    },
  },
  watch: {
    'Filter.AcademicYear'(newValue) {
      this.disableDates = !newValue;

      this.Filter.StartDate = this.minDate;
      this.Filter.EndDate = this.maxDate;

      if (this.disableDates || this.academicYearIdFromPreviosPage) {
        this.Filter.StartDate = null;
        this.Filter.EndDate = null;
      }
    },
  },
  async mounted() {
    await this.loadValidationMessages();
    await this.initFilters();

    if (this.AcademicYears.length > 0) {
      await this.getHistory();
    }
  },
};
</script>

<style scoped>
.block-spacing {
  margin-bottom: 30px;
}

.block-spacing >>> .invalid {
  position: absolute;
  font-size: 13px;
  margin-left: 5px;
}

.btnwidth {
  width: 150px;
  margin-top: 20px;
}
.container-search {
  border-radius: 5px;
  background-color: #f4f6f3;
  padding: 20px;
}
</style>
